<template>
  <div class="row">
    <div class="col flow-text">
      <h5 class="left">Formulario de Entrega a Cliente</h5>
    </div>
  </div>
  <form @submit="submit($event)" id="formulario">
    <div @submit="submit($event)" class="row">
      <div class="col s12 input-field">
        <label class="active">Status del carton</label>
        <input required type="text" v-model="event_status" disabled />
      </div>
      <div class="col s12 input-field">
        <label class="active">Nombre de quien recibe</label>
        <input required type="text" v-model="entregado_a" />
      </div>
    </div>

    <!--  Action button  -->
    <div class="fixed-action-btn">
      <button
        v-if="!cargando"
        type="submit"
        class="btn-floating btn-large blue"
      >
        <i class="large material-icons">save</i>
      </button>
      <div v-else class="preloader-wrapper active">
        <div class="spinner-layer spinner-red-only">
          <div class="circle-clipper left">
            <div class="circle"></div>
          </div>
          <div class="gap-patch">
            <div class="circle"></div>
          </div>
          <div class="circle-clipper right">
            <div class="circle"></div>
          </div>
        </div>
      </div>
    </div>
    <!--  /Action button  -->
  </form>
</template>
<script>
import M from "materialize-css";
//import firebase from "firebase/app";
import Helpers from "@/helpers";
import {
  EVENT_CARTON_ENTREGADO,
  N8N_ENTREGA_CLIENTE_WEBHOOK_URL,
  VUE_APP_ENV,
} from "@/constants";
import Domicilios from "@/tracker/recursos/almacenes_domicilios.json";
import { updateCartons } from "@/tracker/firebase_models/updateCartons";

export default {
  data() {
    return {
      cargando: false,
      entregado_a: "",
      domicilios: Domicilios,
      event_status: "Trabajo entregado",
      delivered_jobs: {},
    };
  },
  props: {
    db: Object,
    shipvia: Object,
    almacen: Object,
    shipvias: Array,
    cartons: Object,
  },
  components: {},
  computed: {
    sucursal() {
      return this.domicilios[this.almacen.iclocid] || {};
    },
    delivered_jobs_list() {
      let delivered_jobs = { ...this.delivered_jobs };
      Object.keys(delivered_jobs).forEach((ccmasterid) => {
        let parts_delivered = Object.keys(delivered_jobs[ccmasterid]).filter(
          (part) => delivered_jobs[ccmasterid][part],
        );
        delivered_jobs[ccmasterid] = parts_delivered;
        if (!parts_delivered.length) {
          delete delivered_jobs[ccmasterid];
        }
      });
      return delivered_jobs;
    },
    jobs_in_cartons() {
      let cartons = Object.values(this.cartons),
        ccmasterids = {};
      cartons.forEach((carton) => {
        if (!ccmasterids[carton.ccmasterid])
          ccmasterids[carton.ccmasterid] = {};
        ccmasterids[carton.ccmasterid][carton.jobpart] = true;
      });
      // Object.keys(ccmasterids).forEach((key) => {
      //   ccmasterids[key] = Object.keys(ccmasterids[key]);
      // });
      return ccmasterids;
    },
    evento() {
      let desc = `Trabajo entregado por ${window.user.displayName}  en la sucursal ${this.almacen.iclocdesc}. Recibió: ${this.entregado_a}`;
      return Helpers.createCartonEvent(
        this.event_status,
        desc,
        window.user.email,
      );
    },
  },
  methods: {
    verificarTodosLosCartones(apiResponseBody) {
      // 1. Validar que la respuesta sea un array válido y no esté vacío
      if (!Array.isArray(apiResponseBody) || apiResponseBody.length === 0) {
        return true; // No hay errores, el flujo continúa normalmente
      }

      // 2. Recorrer cada uno de los errores del response body
      for (let i = 0; i < apiResponseBody.length; i++) {
        const error = apiResponseBody[i];
        const {
          missing_qty,
          planned_quantity,
          job,
          shipmentid,
          scaned_cartons,
        } = error;

        // Construir el mensaje dinámico para el error actual
        const mensaje =
          `⚠️ ¡ATENCIÓN! Faltan ${missing_qty} pieza(s) 📦 de las ${planned_quantity} piezas que conforman el pedido ${job} (Envío ID: ${shipmentid}). Cartones escaneados: ${scaned_cartons} \n\n` +
          `🚛 Confirma esto con el cliente.\n\n` +
          `🛑 Presiona Cancelar para continuar. (${i + 1} de ${
            apiResponseBody.length
          })`;

        // Mostrar el confirm para este error específico
        while (confirm(mensaje));
      }

      // Si terminó de revisar todos los errores y en todos presionó "Cancelar"
      return true;
    },
    webhook_entrega_cliente(ccmasterids_jobparts, idToken) {
      return fetch(`${N8N_ENTREGA_CLIENTE_WEBHOOK_URL}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-Authorization": "Bearer " + idToken,
        },
        body: JSON.stringify(ccmasterids_jobparts),
      });
    },
    notifyEmail() {
      let template_data = {
        entregado_a: this.entregado_a.toUpperCase(),
        sucursal: this.sucursal.name,
        domicilio: this.sucursal.address,
        tels: this.sucursal.tels.join(", "),
      };
      Helpers.notifyEmail(
        this.cartons,
        "soltar-entregado-cliente",
        template_data,
      );
    },
    submit($e) {
      $e.preventDefault();
      if (!this.almacen)
        return M.toast({
          html: "No has seleccionado un almacen",
          classes: "orange",
        });
      this.save();
    },
    async save() {
      let user = window.user,
        batch = {}, // Definimos un lote de registros
        //shipvia = this.shipvia,
        almacen = this.almacen,
        cartons = this.cartons,
        cartons_keys = Object.keys(cartons);

      if (!cartons_keys.length)
        return M.toast({
          html: "No hay paquetes para procesar",
          classes: "red",
        });

      cartons_keys.forEach((cartonId) => {
        // Por cada carton
        let carton_data = cartons[cartonId];
        //docRef = Carton.docRef(cartonId, this.db); // Referencia a un documento

        carton_data.status = this.evento.status;
        carton_data.status_desc = this.evento.desc;
        carton_data.status_code = EVENT_CARTON_ENTREGADO;

        // Agrega evento
        // Agrega evento
        let event_data = {
          ...this.evento,
          status_code: carton_data.status_code,
        };

        carton_data["ARRAY_UNION.eventos"] = event_data;

        //carton_data.shipvia_entrega = shipvia;
        carton_data.iclocdesc = almacen.iclocdesc;
        carton_data.iclocid = almacen.iclocid;
        carton_data.location = `Entregado a ${this.entregado_a}`;
        carton_data.entregado = "SERVER_TIMESTAMP";
        // informacion sobre usuario
        carton_data.last_user_email = user.email;
        // timestamps
        carton_data.updated_at = "SERVER_TIMESTAMP";
        carton_data.updated = new Date().toLocaleString();
        // Sino existe el documento se crea con la información, si existe se actualiza.
        batch[cartonId] = carton_data;
        //resplado en base de datos mongo
        //Carton.backupDoc({ _id: cartonId, ...carton_data });
      });
      this.cargando = true;

      // Solo ejecuta sino es ambiente de desarrollo

      let idToken = await window.user.getIdToken();

      updateCartons(batch, idToken)
        .then(() => {
          // Notificar por correo
          if (VUE_APP_ENV !== "dev") {
            try {
              this.notifyEmail();
            } catch (err) {
              console.log(err);
            }
          }
          if (Object.keys({ ...this.delivered_jobs_list }).length) {
            this.webhook_entrega_cliente(this.cartons, idToken)
              // Actualizar estado de trabajo
              .then((res) => {
                res.json().then((body) => {
                  if ("errors" in body) {
                    this.verificarTodosLosCartones(body.errors);
                  } else {
                    console.log(
                      "Webhook de entrega a cliente ejecutado correctamente",
                    );
                  }
                });

                // Despachar evento para limpiar tablas
                console.log("Estado de trabajo actualizado");
              })
              .catch((err) => {
                console.log("Error al actualizar estado de trabajo: " + err);
              });
          }

          //despachar evento para limpiar tablas
          document.dispatchEvent(new Event("limpiarEscaneos"));
          this.entregado_a = undefined;
          //Todo correcto
          M.toast({ html: "Guardado exitosamente", classes: "green" });
        })
        .catch((err) => {
          M.toast({ html: "Error: " + err, classes: "red" });
        })
        .finally(() => {
          this.cargando = false;
        });
    },
  },
  watch: {
    jobs_in_cartons(newVal) {
      let delivered_jobs = { ...newVal };
      this.delivered_jobs = delivered_jobs;
    },
  },
};
</script>
